<template>
  <div class="label-selected">
    <div class="nav">
      <div
        @click="changeLabelType(item, index)"
        class="van-ellipsis"
        :class="{navActive: navActive == index}"
        v-for="(item, index) in type"
        :key="item.eventLabelClassificationId"
      >
        {{ item.eventLabelClassificationName }}
      </div>
    </div>
    <div class="content">
      <div
        @click="selectedLabel(item)"
        :class="{active: active == item.eventLabelInfoId}"
        class="item"
        v-for="item in list"
        :key="item.eventLabelInfoId"
      >
        {{ item.eventLabelInfoName }}
      </div>
    </div>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getLabelTypeList, getLabelsByType} from '@/api'
export default {
  data() {
    return {
      type: [
        {
          eventLabelClassificationName: '全部',
          eventLabelClassificationId: ''
        }
      ],
      list: [],
      navActive: 0,
      active: 0
    }
  },
  created() {
    this.getLabels('')
    this.init()
    const {index, active} = this.$route.query

    if (index && active) {
      this.active = active
      this.navActive = index
    }
  },
  methods: {
    init() {
      const params = {name: '', pId: 0}
      getLabelTypeList(params).then(res => {
        this.type = [...this.type, ...res.data]
      })
    },
    getLabels(typeId) {
      const params = {
        typeId
      }
      getLabelsByType(params).then(res => {
        this.list = res.data
      })
    },
    changeLabelType(item, index) {
      this.getLabels(item.eventLabelClassificationId)
      this.navActive = index
    },
    selectedLabel(item) {
      this.active = item.eventLabelInfoId
      this.$router.push({
        path: '/discover',
        query: {
          navActive: this.navActive,
          active: this.active,
          index: 2
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.label-selected {
  display: flex;
  height: 100vh;
}
.nav {
  width: 100px;
  background: #f4f6f9;
  height: 100%;
  overflow-y: scroll;
  div {
    word-break: break-all;
    font-weight: 500;
    font-size: 14px;
    padding: 16px 10px 10px 16px;
  }
  div.navActive {
    color: rgba(68, 101, 243, 1);
  }
}
.content {
  background: #fff;
  flex: 1;
  padding: 20px;
  overflow-y: scroll;
  .item {
    word-break: break-all;
    display: inline-block;
    background: #f4f6f9;
    border-radius: 14px;
    font-size: 13px;
    color: rgba(96, 98, 102, 1);
    padding: 8px 14px;
    margin: 0 12px 16px 0;
  }
  .item.active {
    background: rgba(68, 101, 243, 0.16);
    color: rgba(68, 101, 243, 1);
  }
}
</style>
